import produce from 'immer'

export const initialState = {
  error: false,
  isLoading: false,
  portal_name: 'React App',
  company_name: 'Soveluss Technologies',
}

const reducer = (state = initialState, action) =>
  produce(state, (draftState) => {
    switch (action.type) {
      default:
        return draftState
    }
  })

export default reducer